import { html, type TemplateResult } from "lit-html";
import type { Account } from "../data/types";
import { store } from "../data/store";

/**
 * Reusable account-tab strip. Used in cube heads on desktop and as a
 * sub-strip under the primary tabs on mobile. "All" + one per account.
 */
export function renderAccountTabs(
  accounts:          Account[],
  selectedAccountId: "all" | string,
  variant: "desktop" | "mobile" = "desktop",
): TemplateResult {
  const cls = variant === "mobile" ? "acct-tabs acct-tabs--mobile" : "acct-tabs";
  return html`
    <div class="${cls}">
      ${tab("all", "All", selectedAccountId === "all")}
      ${accounts.map((a) =>
        tab(a.id, a.username, selectedAccountId === a.id))}
    </div>
  `;
}

function tab(id: "all" | string, label: string, active: boolean): TemplateResult {
  return html`
    <button
      type="button"
      class="acct-tab ${active ? "acct-tab--active" : ""}"
      @click=${() => store.setSelectedAccountId(id)}
    >${label}</button>
  `;
}
